import { render, staticRenderFns } from "./statistics_model.vue?vue&type=template&id=c7143c9e&scoped=true"
import script from "./statistics_model.vue?vue&type=script&lang=js"
export * from "./statistics_model.vue?vue&type=script&lang=js"
import style0 from "./statistics_model.vue?vue&type=style&index=0&id=c7143c9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7143c9e",
  null
  
)

export default component.exports